import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faNewspaper,
  faShieldAlt,
  faInfoCircle,
  faEnvelope,
  faGavel,
  faHome,
  faFilm,
  faDownload,
  faCopyright,
} from '@fortawesome/free-solid-svg-icons';
import {
  faInstagram,
  faTwitter,
  faLinkedin,
  faGithub,
} from '@fortawesome/free-brands-svg-icons';
import appStore from '../assets/appstore.webp';
import playStore from '../assets/playStore.webp';
import myLogo from '../assets/logo.png';
import './cssComponents/footer.css';
import AdSlot from './ads/AdSlot.tsx';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="watchfolio-footer">
      <AdSlot size="300x250" className="watchfolio-ad-slot--footer" />
      <div className="watchfolio-footer-container">

        {/* Grid */}
        <div className="watchfolio-footer-grid">

          {/* Col 1 — Brand */}
          <div className="watchfolio-footer-column">
            <div className="watchfolio-footer-brand">
              <img
                src={myLogo}
                alt="Watchfolio"
                className="watchfolio-footer-logo watchfolio-footer-logo-large"
              />
            </div>
            <p className="watchfolio-footer-description">
              Organize sua coleção cinematográfica, descubra novos filmes e conecte-se com uma comunidade de cinéfilos apaixonados.
            </p>
            <div className="watchfolio-footer-social">
              <a href="https://instagram.com/watchfolio" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://twitter.com/watchfolio" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a href="https://linkedin.com/company/watchfolio" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
              <a href="https://github.com/watchfolio" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <FontAwesomeIcon icon={faGithub} />
              </a>
            </div>
          </div>

          {/* Col 2 — Navigation */}
          <div className="watchfolio-footer-column">
            <h3>Navegação</h3>
            <ul className="watchfolio-footer-links">
              <li><Link to="/"><FontAwesomeIcon icon={faHome} /> Início</Link></li>
              <li><Link to="/watchfolioWeb"><FontAwesomeIcon icon={faFilm} /> Catálogo</Link></li>
              <li><Link to="/blog"><FontAwesomeIcon icon={faNewspaper} /> Blog</Link></li>
              <li><Link to="/sobre"><FontAwesomeIcon icon={faInfoCircle} /> Sobre</Link></li>
              <li><Link to="/downloadApp"><FontAwesomeIcon icon={faDownload} /> Baixar App</Link></li>
            </ul>
          </div>

          {/* Col 3 — Blog Categories */}
          <div className="watchfolio-footer-column">
            <h3>Blog</h3>
            <ul className="watchfolio-footer-links">
              <li><Link to="/blog?category=Super%20Heróis">Super Heróis</Link></li>
              <li><Link to="/blog?category=Ficção%20Científica">Ficção Científica</Link></li>
              <li><Link to="/blog?category=Comédia">Comédia</Link></li>
              <li><Link to="/blog?category=Aventura">Aventura</Link></li>
              <li><Link to="/blog?category=Atores">Atores & Bastidores</Link></li>
            </ul>
          </div>

          {/* Col 4 — Legal */}
          <div className="watchfolio-footer-column">
            <h3>Legal</h3>
            <ul className="watchfolio-footer-links">
              <li><Link to="/privacidade"><FontAwesomeIcon icon={faShieldAlt} /> Privacidade</Link></li>
              <li><Link to="/privacy-policy"><FontAwesomeIcon icon={faGavel} /> Termos de Uso</Link></li>
              <li><a href="mailto:contato@watchfolio.com"><FontAwesomeIcon icon={faEnvelope} /> Contato</a></li>
              <li><Link to="/deleteAccount">Excluir Conta</Link></li>
            </ul>
          </div>
        </div>

        {/* App Store Badges */}
        <div className="watchfolio-footer-apps">
          <a
            href="https://apps.apple.com/br/app/watchfolio/id6496133036"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={appStore} alt="Baixar na App Store" className="watchfolio-footer-app-badge" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.psiotavio.MovieChecklist"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={playStore} alt="Baixar no Google Play" className="watchfolio-footer-app-badge" />
          </a>
        </div>

        {/* Bottom bar */}
        <div className="watchfolio-footer-bottom">
          <p>
            <FontAwesomeIcon icon={faCopyright} />
            {currentYear} Watchfolio. Todos os direitos reservados.
          </p>
          <p className="watchfolio-footer-disclaimer">
            Dados fornecidos pela API do TMDB. Watchfolio não detém direitos sobre imagens de filmes.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
